"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEEK_NAME = exports.WEEKDAY_KEYS = exports.WEEKDAYS_OBJ = exports.VIEWPORT = exports.TRIP_RETURN = exports.TRIP_ONEWAY = exports.TOGGLE_DATE_SELECTION = exports.RETURN_DATE = exports.MONTH_NAMES = exports.MOBILE = exports.LFC_STATE_KEY = exports.LFC_ROLE = exports.LFC_MEMBER = exports.ICON_SIZE = exports.ICONRIGHT = exports.ICONLEFT = exports.DIVIDER_WIDTH = exports.DEPART_DATE = exports.DEFAULT_RESET_LABEL = exports.DEFAULT_OFFSET = exports.DEFAULT_NO_FARE_LABEL = exports.DEFAULT_LFC_ENDPOINT = exports.DEFAULT_FOOTER_LABEL = exports.DEFAULT_ENVIRONMENT = exports.DEFAULT_DATEFORMATDATA = exports.DEFAULT_CURRENCYFORMATDATE = exports.DEFAULT_CONFIRM_LABEL = exports.DATERANGE_ICON = exports.DATEFORMAT_IND = exports.DATA_FORMAT_STATE_KEY = exports.CHEVRON_RIGHT_ICON = exports.CHEVRON_LEFT_ICON = exports.CALENDAR_VIEW_TYPE = exports.CALENDAR_TYPE = exports.CALENDAR_TRIP_TYPE = exports.CALENDAR_SELECTION_TYPE = exports.CALENDAR_OPEN_CALENDAR_DIRECTION = void 0;
var ICON_SIZE = 'titleNormal';
exports.ICON_SIZE = ICON_SIZE;
var ICONLEFT = 'ChevronLeftIcon';
exports.ICONLEFT = ICONLEFT;
var ICONRIGHT = 'ChevronRightIcon';
exports.ICONRIGHT = ICONRIGHT;
var DIVIDER_WIDTH = '1px';
exports.DIVIDER_WIDTH = DIVIDER_WIDTH;
var VIEWPORT = [695, 1024, 1400]; // mobile: 695,tablet: 1024,desktop: 1400

exports.VIEWPORT = VIEWPORT;
var MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
exports.MONTH_NAMES = MONTH_NAMES;
var WEEKDAY_KEYS = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'];
exports.WEEKDAY_KEYS = WEEKDAY_KEYS;
var WEEK_NAME = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
exports.WEEK_NAME = WEEK_NAME;
var CHEVRON_LEFT_ICON = 'ChevronLeftIcon';
exports.CHEVRON_LEFT_ICON = CHEVRON_LEFT_ICON;
var CHEVRON_RIGHT_ICON = 'ChevronRightIcon';
exports.CHEVRON_RIGHT_ICON = CHEVRON_RIGHT_ICON;
var DEPART_DATE = 'departDate';
exports.DEPART_DATE = DEPART_DATE;
var RETURN_DATE = 'returnDate';
exports.RETURN_DATE = RETURN_DATE;
var MOBILE = 'mobile';
exports.MOBILE = MOBILE;
var WEEKDAYS_OBJ = {
  wed: 'Wed',
  sun: 'Sun',
  fri: 'Fri',
  tue: 'Tue',
  mon: 'Mon',
  thu: 'Thu',
  sat: 'Sat'
};
exports.WEEKDAYS_OBJ = WEEKDAYS_OBJ;
var TRIP_RETURN = 'R';
exports.TRIP_RETURN = TRIP_RETURN;
var TRIP_ONEWAY = 'O';
exports.TRIP_ONEWAY = TRIP_ONEWAY;
var DATERANGE_ICON = 'DateRangeIcon';
exports.DATERANGE_ICON = DATERANGE_ICON;
var DATEFORMAT_IND = 'dd/MM/yyyy';
exports.DATEFORMAT_IND = DATEFORMAT_IND;
var DEFAULT_CONFIRM_LABEL = 'Confirm';
exports.DEFAULT_CONFIRM_LABEL = DEFAULT_CONFIRM_LABEL;
var DEFAULT_RESET_LABEL = 'Reset';
exports.DEFAULT_RESET_LABEL = DEFAULT_RESET_LABEL;
var CALENDAR_TYPE = {
  DEPART: 'depart',
  RETURN: 'return'
};
exports.CALENDAR_TYPE = CALENDAR_TYPE;
var CALENDAR_VIEW_TYPE = {
  DESKTOP: 1,
  MOBILE: 2
};
exports.CALENDAR_VIEW_TYPE = CALENDAR_VIEW_TYPE;
var CALENDAR_SELECTION_TYPE = {
  ONE: 1,
  TWO: 2
};
exports.CALENDAR_SELECTION_TYPE = CALENDAR_SELECTION_TYPE;
var CALENDAR_TRIP_TYPE = {
  ONEWAY: 'O',
  RETURN: 'R'
};
exports.CALENDAR_TRIP_TYPE = CALENDAR_TRIP_TYPE;
var TOGGLE_DATE_SELECTION = {
  DEPART: 1,
  RETURN: 2
};
exports.TOGGLE_DATE_SELECTION = TOGGLE_DATE_SELECTION;
var LFC_STATE_KEY = {
  ONEWAY: 'lfc_prize_oneway',
  RETURN: 'lfc_price_return'
};
exports.LFC_STATE_KEY = LFC_STATE_KEY;
var DATA_FORMAT_STATE_KEY = {
  DATE: 'data_format_date',
  CURRENCY: 'data_format_currency'
};
exports.DATA_FORMAT_STATE_KEY = DATA_FORMAT_STATE_KEY;
var LFC_MEMBER = {
  ANONYMOUS: 0,
  LOGGEDIN: 1
};
exports.LFC_MEMBER = LFC_MEMBER;
var LFC_ROLE = {
  DESKTOP: 0,
  MOBILE: 1
};
exports.LFC_ROLE = LFC_ROLE;
var CALENDAR_OPEN_CALENDAR_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.CALENDAR_OPEN_CALENDAR_DIRECTION = CALENDAR_OPEN_CALENDAR_DIRECTION;
var DEFAULT_DATEFORMATDATA = {
  date: {
    noYear: 'dd mmm',
    fullWithDay: 'ddd, dd mmm',
    noDay: 'mmm yyyy',
    abbreviate: 'dd mmm yyyy',
    general: 'dd/mm/yyyy'
  },
  shortDaysTranslation: {
    wed: 'Wed',
    sun: 'Sun',
    fri: 'Fri',
    tue: 'Tue',
    mon: 'Mon',
    thu: 'Thu',
    sat: 'Sat'
  },
  shortMonthTranslation: {
    mar: 'Mar',
    feb: 'Feb',
    aug: 'Aug',
    sep: 'Sep',
    apr: 'Apr',
    jun: 'Jun',
    jul: 'Jul',
    jan: 'Jan',
    may: 'May',
    nov: 'Nov',
    dec: 'Dec',
    oct: 'Oct'
  },
  fullDaysTranslation: {
    wed: 'Wednesday',
    sun: 'Sunday',
    fri: 'Friday',
    tue: 'Tuesday',
    mon: 'Monday',
    thu: 'Thursday',
    sat: 'Saturday'
  },
  fullMonthTranslation: {
    mar: 'March',
    feb: 'February',
    aug: 'August',
    sep: 'September',
    apr: 'April',
    jun: 'June',
    jul: 'July',
    jan: 'January',
    may: 'May',
    nov: 'November',
    dec: 'December',
    oct: 'October'
  },
  letterDaysTranslation: {
    wed: 'W',
    sun: 'S',
    fri: 'F',
    tue: 'T',
    mon: 'M',
    thu: 'T',
    sat: 'S'
  }
};
exports.DEFAULT_DATEFORMATDATA = DEFAULT_DATEFORMATDATA;
var DEFAULT_CURRENCYFORMATDATE = {
  abbreviation: {
    thousand: 'K',
    million: 'M',
    shortMaxThousand: '4',
    shortMaxMillion: '6'
  },
  AAA: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'AAA',
    shortDecimalMillion: '2',
    shortSymbol: 'null',
    shortFormat: 'v',
    shortDecimalThousand: '1'
  },
  IDR: {
    thousandSeparator: ',',
    longDecimal: 'null',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'IDR',
    shortDecimalMillion: '2',
    shortSymbol: 'null',
    shortFormat: 'v',
    shortDecimalThousand: 'null'
  },
  VND: {
    thousandSeparator: ',',
    longDecimal: 'null',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'VND',
    shortDecimalMillion: '2',
    shortSymbol: 'null',
    shortFormat: 'v',
    shortDecimalThousand: 'null'
  },
  KRW: {
    thousandSeparator: ',',
    longDecimal: 'null',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'KRW',
    shortDecimalMillion: '2',
    shortSymbol: '₩',
    shortFormat: 'sv',
    shortDecimalThousand: 'null'
  },
  INR: {
    thousandSeparator: ',',
    longDecimal: 'null',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'INR',
    shortDecimalMillion: '2',
    shortSymbol: '₹',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  THB: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'THB',
    shortDecimalMillion: '2',
    shortSymbol: '฿',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  JPY: {
    thousandSeparator: ',',
    longDecimal: 'null',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'JPY',
    shortDecimalMillion: '2',
    shortSymbol: '¥',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  PHP: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'PHP',
    shortDecimalMillion: '2',
    shortSymbol: '₱',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  CNY: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'CNY',
    shortDecimalMillion: '2',
    shortSymbol: '¥',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  GBP: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'GBP',
    shortDecimalMillion: '2',
    shortSymbol: '£',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  EUR: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'EUR',
    shortDecimalMillion: '2',
    shortSymbol: '€',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  USD: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'USD',
    shortDecimalMillion: '2',
    shortSymbol: '$',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  NZD: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'NZD',
    shortDecimalMillion: '2',
    shortSymbol: '$',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  SGD: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'SGD',
    shortDecimalMillion: '2',
    shortSymbol: '$',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  TWD: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'TWD',
    shortDecimalMillion: '2',
    shortSymbol: '$',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  },
  HKD: {
    thousandSeparator: ',',
    longDecimal: '2',
    longFormat: 'v s',
    decimalSeparator: '.',
    longSymbol: 'HKD',
    shortDecimalMillion: '2',
    shortSymbol: '$',
    shortFormat: 'sv',
    shortDecimalThousand: '1'
  }
};
exports.DEFAULT_CURRENCYFORMATDATE = DEFAULT_CURRENCYFORMATDATE;
var DEFAULT_LFC_ENDPOINT = {
  DEVELOPMENT: "https://k.dev-apiairasia.com/availabledates/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}",
  STAGING: "https://k.stg-apiairasia.com/availabledates/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}",
  // eslint-disable-next-line max-len
  PRE_PRODUCTION: "https://k.preprod-apiairasia.com/availabledates-pwa/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}",
  PRODUCTION: "https://k.airasia.com/availabledates-pwa/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}"
};
exports.DEFAULT_LFC_ENDPOINT = DEFAULT_LFC_ENDPOINT;
var DEFAULT_ENVIRONMENT = 'DEVELOPMENT';
exports.DEFAULT_ENVIRONMENT = DEFAULT_ENVIRONMENT;
var DEFAULT_FOOTER_LABEL = 'Lowest all-in fare in {0} for 1 Adult';
exports.DEFAULT_FOOTER_LABEL = DEFAULT_FOOTER_LABEL;
var DEFAULT_NO_FARE_LABEL = 'Unable to display the lowest fares';
exports.DEFAULT_NO_FARE_LABEL = DEFAULT_NO_FARE_LABEL;
var DEFAULT_OFFSET = {
  DEPART: 7,
  RETURN: 10,
  RANGE: 3
};
exports.DEFAULT_OFFSET = DEFAULT_OFFSET;